/**
 * Product Modal functionality for single product page
 */

export default function productModal() {
  const modal = document.getElementById('productModal');

  if (modal) {
    // Global functions for Vue template
    window.openProductModal = function(categoryIndex, termId, loopIndex) {
    const modalId = `${categoryIndex}-${termId}-${loopIndex}`;
    const modalData = document.querySelector(`[data-id="${modalId}"]`);

    if (!modalData) {
      return;
    }

    // Get data from hidden content
    const gallery = modalData.querySelector('.modal-gallery');
    const description = modalData.querySelector('.modal-description');
    const additional = modalData.querySelector('.modal-additional');

    // Get the main image from the card
    const cardImage = modalData.closest('.product-card').querySelector('img');
    const titleElement = modalData.closest('.product-card').querySelector('h3 button') || 
                        modalData.closest('.product-card').querySelector('h3');
    const title = titleElement.textContent.trim();

    // Populate modal content
    document.getElementById('modal-title').textContent = title;
    const modalImage = document.getElementById('modal-image');
    modalImage.src = cardImage.src;
    modalImage.alt = cardImage.alt;

    // Make main image clickable for lightbox (only on desktop)
    if (window.innerWidth >= 768) {
      modalImage.style.cursor = 'pointer';
      modalImage.onclick = () => openImageLightbox(modalImage.src, modalImage.alt);
    }

    // Set description
    const modalDescription = document.getElementById('modal-description');
    if (description) {
      modalDescription.innerHTML = description.innerHTML;
    }

    // Set additional content (zawsze widoczny)
    const modalAdditional = document.getElementById('modal-additional-content');
    if (additional) {
      modalAdditional.innerHTML = additional.innerHTML;
    }

    // Populate gallery thumbnails
    const modalGallery = document.getElementById('modal-gallery');
    modalGallery.innerHTML = '';

    if (gallery) {
      const galleryItems = gallery.querySelectorAll('.gallery-item');

      // Add main image as first thumbnail
      const mainThumb = createThumbnail(cardImage.src, cardImage.alt, true);
      modalGallery.appendChild(mainThumb);

      // Add other gallery images (skip first one as it's already added as main thumbnail)
      galleryItems.forEach((item, index) => {
        // Skip the first gallery item since it's the same as the main image
        if (index === 0) return;
        
        const img = item.querySelector('img');
        if (img) {
          const thumb = createThumbnail(img.src, img.alt || `Gallery image ${index + 1}`, false);
          modalGallery.appendChild(thumb);
        }
      });
    }

    // Show modal
    modal.classList.remove('hidden');
    document.body.classList.add('overflow-hidden');
  };

  window.closeProductModal = function() {
    modal.classList.add('hidden');
    document.body.classList.remove('overflow-hidden');
  };

  // Image Lightbox functionality
  let currentGallery = [];
  let currentImageIndex = 0;

  window.openImageLightbox = function(src, alt, galleryImages = null) {
    // Check if mobile device - don't open lightbox on mobile
    if (window.innerWidth < 768) {
      return;
    }
    
    // Create lightbox if it doesn't exist
    let lightbox = document.getElementById('imageLightbox');
    if (!lightbox) {
      lightbox = createImageLightbox();
      document.body.appendChild(lightbox);
    }

    // Set up gallery
    if (galleryImages && galleryImages.length > 0) {
      currentGallery = galleryImages;
      currentImageIndex = galleryImages.findIndex(img => img.src === src);
      if (currentImageIndex === -1) currentImageIndex = 0;
    } else {
      // Collect images from modal gallery
      const modalGallery = document.getElementById('modal-gallery');
      if (modalGallery) {
        const thumbnails = modalGallery.querySelectorAll('img');
        currentGallery = Array.from(thumbnails).map(img => ({
          src: img.src,
          alt: img.alt
        }));
        currentImageIndex = currentGallery.findIndex(img => img.src === src);
        if (currentImageIndex === -1) currentImageIndex = 0;
      } else {
        currentGallery = [{ src, alt }];
        currentImageIndex = 0;
      }
    }

    // Update lightbox content
    updateLightboxImage();
    updateLightboxControls();

    // Show lightbox (only on desktop)
    lightbox.classList.remove('hidden');
    if (window.innerWidth >= 768) {
      lightbox.classList.add('flex');
    }
    document.body.style.overflow = 'hidden';
  };

  window.closeImageLightbox = function() {
    const lightbox = document.getElementById('imageLightbox');
    if (lightbox) {
      lightbox.classList.add('hidden');
      lightbox.classList.remove('flex');
      document.body.style.overflow = '';
    }
  };

  window.prevLightboxImage = function() {
    if (currentGallery.length > 1) {
      currentImageIndex = currentImageIndex > 0 ? currentImageIndex - 1 : currentGallery.length - 1;
      updateLightboxImage();
      updateLightboxControls();
    }
  };

  window.nextLightboxImage = function() {
    if (currentGallery.length > 1) {
      currentImageIndex = currentImageIndex < currentGallery.length - 1 ? currentImageIndex + 1 : 0;
      updateLightboxImage();
      updateLightboxControls();
    }
  };

  function updateLightboxImage() {
    const lightboxImage = document.getElementById('lightbox-image');
    if (lightboxImage && currentGallery[currentImageIndex]) {
      lightboxImage.src = currentGallery[currentImageIndex].src;
      lightboxImage.alt = currentGallery[currentImageIndex].alt;
    }
  }

  function updateLightboxControls() {
    const prevBtn = document.getElementById('lightbox-prev');
    const nextBtn = document.getElementById('lightbox-next');
    const counter = document.getElementById('lightbox-counter');

    if (currentGallery.length > 1) {
      if (prevBtn) prevBtn.style.display = 'block';
      if (nextBtn) nextBtn.style.display = 'block';
      if (counter) counter.textContent = `${currentImageIndex + 1} / ${currentGallery.length}`;
    } else {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      if (counter) counter.textContent = '';
    }
  }

  function createImageLightbox() {
    const lightbox = document.createElement('div');
    lightbox.id = 'imageLightbox';
    lightbox.className = 'fixed inset-0 z-[10000] bg-black bg-opacity-50 items-center justify-center p-4 hidden';

    lightbox.innerHTML = `
      <div class="relative max-w-full max-h-full">
        <!-- Close button -->
        <button onclick="closeImageLightbox()" class="absolute top-4 right-4 text-black text-5xl hover:text-gray-700 z-10 p-2">
          <svg class="w-16 h-16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        <!-- Counter -->
        <div id="lightbox-counter" class="absolute top-4 left-4 text-black text-lg font-medium z-10 px-3 py-1 rounded"></div>

        <!-- Previous button -->
        <button id="lightbox-prev" onclick="prevLightboxImage()" class="absolute left-4 top-1/2 transform -translate-y-1/2 text-black hover:text-gray-700 z-10 p-2">
          <svg class="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        <!-- Next button -->
        <button id="lightbox-next" onclick="nextLightboxImage()" class="absolute right-4 top-1/2 transform -translate-y-1/2 text-black hover:text-gray-700 z-10 p-2">
          <svg class="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </button>

        <!-- Main image -->
        <img id="lightbox-image" src="" alt="" class="max-w-full max-h-full object-contain" />
      </div>
    `;

    // Close on background click
    lightbox.addEventListener('click', (e) => {
      if (e.target === lightbox) {
        closeImageLightbox();
      }
    });

    // Close on Escape key and add arrow navigation
    document.addEventListener('keydown', (e) => {
      if (!lightbox.classList.contains('hidden')) {
        if (e.key === 'Escape') {
          closeImageLightbox();
        } else if (e.key === 'ArrowLeft') {
          prevLightboxImage();
        } else if (e.key === 'ArrowRight') {
          nextLightboxImage();
        }
      }
    });

    return lightbox;
  }

  function createThumbnail(src, alt, isActive = false) {
    const thumb = document.createElement('div');
    thumb.className = `aspect-square cursor-pointer overflow-hidden border ${
      isActive ? 'border-gray-500' : 'border-gray-50 hover:border-gray-300'
    }`;

    const img = document.createElement('img');
    img.src = src;
    img.alt = alt;
    img.className = 'w-full h-full object-cover';

    thumb.appendChild(img);

    thumb.addEventListener('click', () => {
      // Update main image
      const modalImage = document.getElementById('modal-image');
      modalImage.src = src;
      modalImage.alt = alt;

      // Update lightbox click handler (only on desktop)
      if (window.innerWidth >= 768) {
        modalImage.onclick = () => openImageLightbox(src, alt);
      }

      // Update active state
      const modalGallery = document.getElementById('modal-gallery');
      modalGallery.querySelectorAll('div').forEach(t => {
        t.className = t.className.replace('border-gray-500', 'border-gray-50 hover:border-gray-300');
      });
      thumb.className = thumb.className.replace('border-gray-50 hover:border-gray-300', 'border-gray-500');
    });

    return thumb;
  }

  // Close modal on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.classList.contains('hidden')) {
      window.closeProductModal();
    }
  });
  } // End of if (modal)

  // Quick View Modal for taxonomy pages
  const quickViewModal = document.getElementById('quickViewModal');
  
  if (quickViewModal) {
    window.openQuickViewModal = async function(productId) {
      const content = document.getElementById('quickViewContent');
      
      // Clear previous content and show loading state
      content.innerHTML = `
        <div class="sm:col-span-12 text-center py-16">
          <div class="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
          <p class="mt-4 text-gray-600">Ładowanie danych produktu...</p>
        </div>
      `;
      
      // Show modal with loading state
      quickViewModal.classList.remove('hidden');
      document.body.classList.add('overflow-hidden');
      
      try {
        // Fetch product data via custom API endpoint
        const response = await fetch(`${window.location.origin}/wp-json/api/products/${productId}`);
        const data = await response.json();
        
        // Build modal content
        let html = '<div class="sm:col-span-4 lg:col-span-4 mt-[3.2rem]">';
        
        // Gallery section with simple layout
        const gallery = data.gallery || [];
        if (gallery.length > 0) {
          // Znajdź pierwszy obraz (nie video)
          const firstImage = gallery.find(item => !item.if_video);
          const firstImageUrl = firstImage?.img?.url || gallery[0]?.img?.url;
          const firstImageAlt = firstImage?.img?.alt || data.title;
          
          html += `
            <div class="products__image w-full my-[3.2rem] tablet:mt-0">
              <div class="products__swiper">
                <div class="bg-bg-gray3">
                  <div class="flex min-w-full min-h-[auto] justify-center select-none">
                    <img id="quickViewMainImage" src="${firstImageUrl}" alt="${firstImageAlt}" class="m-auto w-full h-auto object-contain">
                  </div>
                </div>
                <div class="products-thumbs-swiper mt-[3.2rem] tablet:mt-[1.6rem]">
                  <div class="flex gap-[1.6rem] flex-wrap">
          `;
          
          gallery.forEach((item, index) => {
            if (!item.if_video && item.img) {
              html += `
                <div class="cursor-pointer transition hover:brightness-50 select-none w-[7.4rem]" onclick="changeQuickViewMainImage('${item.img.url}', '${item.img.alt || data.title}', this)">
                  <img src="${item.img.url}" alt="${item.img.alt || data.title}" class="w-full h-auto">
                </div>
              `;
            }
          });
          
          html += `
                  </div>
                </div>
              </div>
            </div>
          `;
        } else {
          html += `
            <div class="w-full bg-gray-100">
              <img src="" alt="${data.title}" class="w-full h-auto object-contain">
            </div>
          `;
        }
        
        html += '</div>';
        
        // Content section
        html += '<div class="sm:col-span-8 lg:col-span-8">';
        html += `<div class="h3 text-[2.8rem] leading-[3.4rem] mb-[2rem] mt-[3.2rem]">${data.title}</div>`;
        
        // Short description (excerpt z ACF)
        const excerpt = data.excerpt;
        if (excerpt) {
          html += '<div class="description-content-product copy3 mb-[3.2rem]">';
          html += excerpt;
          html += '</div>';
        }
        
        // Files to download section
        const filesDocuments = data.files_documents;
        if (filesDocuments && filesDocuments.category && filesDocuments.category.length > 0) {
          html += '<div class="my-[3.2rem]"><div class="h5 mb-[1.6rem]">Pliki do pobrania</div>';
          html += '<div class="flex flex-col gap-[1.6rem]">';
          filesDocuments.category.forEach(cat => {
            if (cat.documents && cat.documents.length > 0) {
              cat.documents.forEach(doc => {
                const link = doc.type === 'link' ? doc.link : doc.file;
                const downloadAttr = doc.type === 'file' ? 'download' : '';
                html += `
                  <div class="">
                    <a href="${link}" ${downloadAttr} class="flex justify-between items-center">
                      <span class="copy3 underline underline-offset-4 pr-[2rem]">${doc.name}</span>
                      <i class="tlc-icon-download text-[1.6rem]"></i>
                    </a>
                  </div>
                `;
              });
            }
          });
          html += '</div></div>';
        }
        
        html += '</div>';
        
        content.innerHTML = html;
        
      } catch (error) {
        content.innerHTML = `
          <div class="sm:col-span-12 text-center py-8">
            <p class="text-red-600">Nie udało się załadować danych produktu.</p>
          </div>
        `;
      }
    };
    
    window.changeQuickViewMainImage = function(src, alt, thumbElement) {
      const mainImage = document.getElementById('quickViewMainImage');
      if (mainImage) {
        mainImage.src = src;
        mainImage.alt = alt;
      }
      
      // Update active thumbnail - remove active class from all
      const thumbs = document.querySelectorAll('#quickViewContent .products-thumbs-swiper > div > div');
      thumbs.forEach(thumb => {
        thumb.style.opacity = '1';
      });
      
      // Add active state to clicked thumbnail
      if (thumbElement) {
        thumbElement.style.opacity = '0.5';
      }
    };
    
    window.closeQuickViewModal = function() {
      quickViewModal.classList.add('hidden');
      document.body.classList.remove('overflow-hidden');
      
      // Clear modal content after closing to prevent showing old data on next open
      const content = document.getElementById('quickViewContent');
      if (content) {
        content.innerHTML = '';
      }
    };
    
    // Close on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !quickViewModal.classList.contains('hidden')) {
        window.closeQuickViewModal();
      }
    });
  }
}
